module.exports = __webpack_public_path__ + "img/softgrove-2.598206e2.jpeg";